import 'css-chunksrc/feature/provision/WaitSplash.module.scss';export default {
  "backdrop": "WaitSplash_backdrop",
  "container": "WaitSplash_container",
  "icon": "WaitSplash_icon",
  "message": "WaitSplash_message"
};